// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"69":"344e04b9","610":"5461cf3f"}[chunkId] + ".chunk.css";
};